module.exports = __webpack_public_path__ + "img/indexr.301f7bf4.png";